import React from 'react';

import LoginView from '../auth/Login';
import RegisterView from '../auth/Register';
import PasswordResetView from '../auth/PasswordReset';
import ChangePasswordView from '../auth/ChangePassword';
import RegistrationConfirmView from '../auth/RegistrationConfirmation';
import InvitationConfirmView from '../auth/InvitationConfirm';

const authRoutes = [
  {
    path: '/login',
    renderer: (params = {}): JSX.Element => <LoginView {...params} />,
  },
  {
    path: '/register',
    renderer: (params = {}): JSX.Element => <RegisterView {...params} />,
  },
  {
    path: '/passwordReset',
    renderer: (params = {}): JSX.Element => <PasswordResetView {...params} />,
  },
  {
    path: '/changePassword/:id/:token',
    renderer: (params = {}): JSX.Element => <ChangePasswordView {...params} />,
  },
  {
    path: '/registrationConfirm/:token',
    renderer: (params = {}): JSX.Element => (
      <RegistrationConfirmView {...params} />
    ),
  },
  {
    path: '/invitationConfirm/:token',
    renderer: (params = {}): JSX.Element => (
      <InvitationConfirmView {...params} />
    ),
  },
];

export default authRoutes;
